import { render } from "./ProjectItem.vue?vue&type=template&id=fae7ea56&scoped=true"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"

import "./ProjectItem.vue?vue&type=style&index=0&id=fae7ea56&scoped=true&lang=css"

import exportComponent from "D:\\Learning\\Projects\\allankirui.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae7ea56"]])

export default __exports__